var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-icons"},_vm._l((_vm.platformsData),function(icon){return _c('v-icon',{key:icon,staticClass:"platform-icon"},[_vm._v(" "+_vm._s(_vm.iconMap[icon])+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }